
 const Images = [
    {
        url :'https://auth.geeksforgeeks.org/user/djkhanna835/practice/',
        // image: 'http://www.geeksforgeeks.org/wp-content/uploads/gfg_200X200-1.png',
        image: 'https://levelupcollege.com/wp-content/uploads/2022/07/gfg-logo.png',
        title:'GEEKS FOR GEEKS',
        totalQuestion: '350+',
    },
    {
        url :'https://www.hackerrank.com/djkhanna835?hr_r=1',
        // image: 'https://upload.wikimedia.org/wikipedia/commons/4/40/HackerRank_Icon-1000px.png',
        image: 'https://www.finsmes.com/wp-content/uploads/2022/03/hackerrank.png',
        title:'HACKER RANK',
        totalQuestion: '100+',
    },
    {
        url :'https://leetcode.com/djkhanna835/',
        // image: 'https://raw.githubusercontent.com/LeetCode-OpenSource/vscode-leetcode/master/resources/LeetCode.png',
        image:'https://miro.medium.com/max/1400/1*nFgF8PFbUBqaRVijajytog.jpeg',
        title:'LEET CODE',
        totalQuestion: '110+',
    },
    {
        url :'https://www.codingninjas.com/codestudio/profile/ad263f47-ef85-4ec5-8b3a-2be504bb7f8c',
        image: 'https://levelupcollege.com/wp-content/uploads/2021/10/coding-ninjas-logo-white.png',
        title:'CODING NINJAS',
        totalQuestion: '110+',
    },
    {
        url :'https://www.codechef.com/users/ritik_kumar123',
        image: 'https://upload.wikimedia.org/wikipedia/en/thumb/7/7b/Codechef%28new%29_logo.svg/1200px-Codechef%28new%29_logo.svg.png',
        title:'CODE CHEF',
        totalQuestion: '164+',
    },
 ];
export default Images;